import { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { categories } from "@/mocks/categories";

const navLinks = [
  { label: "首页", to: "/" },
  { label: "爆料中心", to: "/rumors" },
  { label: "关于我们", to: "/about" },
];

export default function SiteHeader() {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [catOpen, setCatOpen] = useState(false);
  const [query, setQuery] = useState("");
  const catRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setMenuOpen(false);
    setCatOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (catRef.current && !catRef.current.contains(e.target as Node)) {
        setCatOpen(false);
      }
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const isActive = (to: string) =>
    to === "/" ? location.pathname === "/" : location.pathname.startsWith(to);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const value = query.trim();
    navigate(value ? `/rumors?q=${encodeURIComponent(value)}` : "/rumors");
  };

  return (
    <header className="sticky top-0 z-50">
      <div className="bg-primary-600 text-background-50">
        <div className="container-editorial flex h-9 items-center justify-between gap-4 text-xs">
          <div className="flex items-center gap-2 min-w-0">
            <span className="flex items-center gap-1.5 shrink-0 font-medium tracking-wide">
              <span className="w-2 h-2 rounded-full bg-accent-400 animate-pulse-dot" />
              实时爆料
            </span>
            <span className="hidden sm:block truncate text-background-50/80">
              知情人透露：某平台流量规则一周内两次微调
            </span>
          </div>
          <span className="hidden md:block shrink-0 text-background-50/75">
            一手信息持续更新中
          </span>
        </div>
      </div>

      <div className="border-b border-background-200/80 bg-background-50/95 backdrop-blur-md">
        <div className="container-editorial flex h-16 md:h-[72px] items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2.5 shrink-0 group">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-600 text-background-50">
              <i className="ri-flashlight-fill text-lg" />
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-xl font-black tracking-tight text-foreground-950">
                热点内幕
              </span>
              <span className="mt-0.5 text-[10px] tracking-[0.22em] text-foreground-500 uppercase">
                Insider Wire
              </span>
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-1" aria-label="主导航">
            {navLinks.slice(0, 2).map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`whitespace-nowrap rounded-md px-3.5 py-2 text-sm font-medium transition-colors ${
                  isActive(link.to)
                    ? "bg-primary-50 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`}
              >
                {link.label}
              </Link>
            ))}

            <div className="relative" ref={catRef}>
              <button
                type="button"
                onClick={() => setCatOpen((v) => !v)}
                className="flex items-center gap-1 whitespace-nowrap rounded-md px-3.5 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
                aria-expanded={catOpen}
              >
                栏目导航
                <i className={`ri-arrow-down-s-line text-base transition-transform ${catOpen ? "rotate-180" : ""}`} />
              </button>
              {catOpen && (
                <div className="absolute left-0 top-full mt-2 w-72 rounded-lg border border-background-200 bg-background-50 p-2 animate-fade-up">
                  {categories.map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/rumors?cat=${cat.slug}`}
                      className="flex items-start gap-3 rounded-md px-3 py-2.5 transition-colors hover:bg-background-100"
                    >
                      <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                        <i className={`${cat.icon} text-base`} />
                      </span>
                      <span className="min-w-0">
                        <span className="block text-sm font-medium text-foreground-950">{cat.name}</span>
                        <span className="mt-0.5 block truncate text-xs text-foreground-500">{cat.desc}</span>
                      </span>
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link
              to="/about"
              className={`whitespace-nowrap rounded-md px-3.5 py-2 text-sm font-medium transition-colors ${
                isActive("/about")
                  ? "bg-primary-50 text-primary-700"
                  : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
              }`}
            >
              关于我们
            </Link>
          </nav>

          <div className="flex items-center gap-2">
            <form onSubmit={submitSearch} className="hidden md:flex items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3 py-1.5">
              <i className="ri-search-line text-base text-foreground-500" />
              <input
                type="text"
                name="q"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="搜索爆料关键词"
                className="w-32 lg:w-40 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
              />
            </form>

            <Link
              to="/rumors"
              className="hidden sm:inline-flex whitespace-nowrap items-center gap-1.5 rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
            >
              <i className="ri-fire-line text-base" />
              看爆料
            </Link>

            <button
              type="button"
              onClick={() => setMenuOpen((v) => !v)}
              className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 lg:hidden"
              aria-label="打开菜单"
              aria-expanded={menuOpen}
            >
              <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-xl`} />
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="border-t border-background-200 bg-background-50 lg:hidden animate-fade-in">
            <div className="container-editorial py-4">
              <form onSubmit={submitSearch} className="mb-4 flex items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3.5 py-2.5">
                <i className="ri-search-line text-base text-foreground-500" />
                <input
                  type="text"
                  name="q"
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  placeholder="搜索爆料关键词"
                  className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
                />
              </form>
              <div className="flex flex-col gap-1">
                {navLinks.map((link) => (
                  <Link
                    key={link.to}
                    to={link.to}
                    className={`rounded-md px-3 py-2.5 text-sm font-medium ${
                      isActive(link.to) ? "bg-primary-50 text-primary-700" : "text-foreground-800"
                    }`}
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
              <p className="mt-4 mb-2 px-3 text-xs font-medium tracking-wide text-foreground-500">栏目</p>
              <div className="grid grid-cols-2 gap-1">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/rumors?cat=${cat.slug}`}
                    className="flex items-center gap-2 rounded-md px-3 py-2 text-sm text-foreground-700"
                  >
                    <i className={`${cat.icon} text-base text-secondary-600`} />
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}